module.exports = __webpack_public_path__ + "img/icon-lastyear.acfb9ac0.png";